"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _Table = require("./Table");

var _TableHead = require("./TableHead");

var _TableBody = require("./TableBody");

var _TableCell = require("./TableCell");

var _TableRow = require("./TableRow");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  columns: _propTypes.array,
  data: _propTypes.array,
  rowsOptions: (0, _propTypes.shape)({
    striped: _propTypes.bool,
    stripeColorEven: _propTypes.string,
    stripeColorOdd: _propTypes.string
  }),
  children: _propTypes.node,
  fullWidth: _propTypes.bool,
  'data-testid': _propTypes.string
} : {};
const defaultProps = {
  component: 'div',
  fullWidth: false
};

const DataTable = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  const {
    component,
    className,
    columns,
    data,
    rowsOptions,
    fullWidth,
    ...other
  } = props;
  return (0, _core.jsx)(_components.DataTable, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className,
    "data-testid": props['data-testid']
  }, other), (0, _core.jsx)(_Table.Table, {
    fullWidth: fullWidth
  }, columns && (0, _core.jsx)(_TableHead.TableHead, null, (0, _core.jsx)(_TableRow.TableRow, null, columns.map(column => {
    return (0, _core.jsx)(_TableCell.TableCell, {
      key: column
    }, column);
  }))), data && (0, _core.jsx)(_TableBody.TableBody, rowsOptions, data.map((cells, index) => {
    return (0, _core.jsx)(_TableRow.TableRow, {
      key: index
    }, cells.map(cell => {
      return (0, _core.jsx)(_TableCell.TableCell, {
        key: cell
      }, cell);
    }));
  })), props.children));
});

exports.DataTable = DataTable;
process.env.NODE_ENV !== "production" ? DataTable.propTypes = propTypes : void 0;
DataTable.defaultProps = defaultProps;